import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getBookingWidgetReviews = createAsyncThunk(
    'booking-widget/get-reviews',
    async (params = {}) => {
        const url = params.reviewsUrl;

        const response = await axios.get(url);

        return response.data;
    }
);

export const bookingWidgetReviewsSlice = createSlice({
    name: 'reviews',
    initialState: {
        reviews: [],
        reviewsText: '',
        totalReviewsText: '',
        guestScoreText: '',
        guestScore: '',
        guestScoreValueText: '',
        sortByScoreOptions: [],
        channelScores: [],
        sortByCommentsOptions: [],
        channelExtras: [],
        showCommentsByCountryOptions: [],
        isDrawerOpen: false,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
    },
    reducers: {
        toggle: (state) => {
            state.isDrawerOpen = !state.isDrawerOpen;
        },
        setReviews: (state, action) => {
            state.reviews = [...state.reviews, ...action.payload.reviews];
        },
        setSortByScoreOptions: (state, action) => {
            state.sortByScoreOptions = action.payload.sortByScoreOptions;
        },
        resetReviews: (state) => {
            state.reviews = [];
        },
    },
    extraReducers: {
        [getBookingWidgetReviews.fulfilled]: (state, { payload }) => {
            state.reviews = payload.channelComments || [];
            state.reviewsText = payload?.reviewsText;
            state.totalReviews = payload?.totalReviews;
            state.totalReviewsText = payload?.totalReviewsText;
            state.guestScoreText = payload?.guestScoreText;
            state.guestScore = payload?.guestScore;
            state.channelExtras = payload?.channelExtras;
            state.guestScoreValueText = payload?.guestScoreValueText;
            state.channelScores = payload?.channelScores
                ?.filter((channel) => channel?.channelName)
                .map((channel) => {
                    const channelScore = parseFloat(
                        channel.channelScore.replace(',', '.')
                    );
                    const channelScoreOutOf = parseFloat(
                        channel.channelScoreOutOf
                            .replace('/', '')
                            .replace(',', '.')
                    );
                    const channelScorePercentage =
                        (channelScore / channelScoreOutOf) * 100;

                    return {
                        ...channel,
                        channelScorePercentage,
                    };
                });
            state.sortByCommentsOptions = payload?.sortByCommentsOptions;
            state.sortByScoreOptions = payload?.sortByScoreOptions;
            state.sortBySeasonOptions = payload?.sortBySeasonOptions;
            state.showCommentsByCountryOptions =
                payload?.sortByCommentsLanguage;
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            state.errorMessage = '';
        },
        [getBookingWidgetReviews.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = true;
            state.errorMessage = '';
        },
        [getBookingWidgetReviews.pending]: (state) => {
            state.isFetching = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = '';
        },
    },
});

export const { toggle, resetReviews, setReviews, setSortByScoreOptions } =
    bookingWidgetReviewsSlice.actions;
